module.exports = __webpack_public_path__ + "1ce8a9e4b9e21ca375206e4c3f5bbf9c.bg_inner-mobile.webp";


//////////////////
// WEBPACK FOOTER
// ./components/background/assets/bg_inner-mobile.webp
// module id = h0oi
// module chunks = 0